// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disabled_btn.v-btn.v-btn--disabled[data-v-5e7b64b0],.save_btn.v-btn--disabled[data-v-5e7b64b0]{background-color:#d3d3d3}.sticky_toolbar[data-v-5e7b64b0]{position:sticky;z-index:2;background:#fff;box-shadow:0 10px 18px -8px hsla(300,5%,54%,.5)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
